;(function () {
  'use strict'
  angular.module('obex').factory('clientSelectService', ['$q', '$window', 'organizations', 'authService', '$rootScope',
    function ($q, $window, organizations, authService, $rootScope) {
      const storage = $window.localStorage;
      const selectedClient = {};
      return {
        getSelectableClients(boolAllClients = false) {
          const logInUser = authService.getLoginMember();          
          if (logInUser.Role == 1 || logInUser.Role == 2) {   
            if(boolAllClients) {      
              return organizations.getSelectedAgencyClients(logInUser.Organization.Id,true).then(response => {
                const allOrganizationInfo = response.data;
                console.log(response.data);
                const allOrganizationMap = allOrganizationInfo
                  .map(function (org) {               
                    return {
                      name: org.Name,
                      id: org.Id,
                      travelAgencyId: org.TravelAgencyId,
                      allowOpenBookings: org.AllowOpenBookings,
                      chatAppName: org.ChatAppName
                    }
                  })
                  .sort(function (a, b) {
                    return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
                  });
    
                return $q.when(allOrganizationMap);
              });  
            } else {
              return organizations.getSelectedAgencyClients(logInUser.Organization.Id).then(response => {
                const allOrganizationInfo = response.data;
                console.log(response.data);
                const allOrganizationMap = allOrganizationInfo.filter(function(obj) {
                  return !obj.Inactive;
                })
                  .map(function (org) {               
                    return {
                      name: org.Name,
                      id: org.Id,
                      travelAgencyId: org.TravelAgencyId,
                      allowOpenBookings: org.AllowOpenBookings,
                      chatAppName: org.ChatAppName
                    }
                  })
                  .sort(function (a, b) {
                    return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
                  });
    
                return $q.when(allOrganizationMap);
              });  
            }            
          } else {
            return organizations.getClients(boolAllClients).then(response => {
              const allOrganizationInfo = response.data;
              console.log(response.data);
              const allOrganizationMap = allOrganizationInfo
                .map(function (org) {               
                  return {
                    name: org.Name,
                    id: org.Id,
                    travelAgencyId: org.TravelAgencyId,
                    allowOpenBookings: org.AllowOpenBookings,
                    chatAppName: org.ChatAppName
                  }
                })
                .sort(function (a, b) {
                  return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
                });
              return $q.when(allOrganizationMap);
            });
          }                    
        },
        setSelectedClient(id, name, allowOpenBookings, chatAppName) {          
          selectedClient.id = id;
          selectedClient.name = name;
          selectedClient.allowOpenBookings = allowOpenBookings;   
          selectedClient.ChatAppName = chatAppName       
          storage.setItem('selectedClient', JSON.stringify(selectedClient))
          console.log('selectedClient set to', selectedClient)
          $rootScope.$broadcast('clientChangeEvent', {
            clientID: selectedClient.id,
            allowOpenBookings: allowOpenBookings,
            ChatAppName: chatAppName
          });
        },
        getSelectedClient() {
          let sc = selectedClient          
          if (sc.id === undefined || sc.name === undefined) {
            if (storage.getItem('selectedClient')) {
              sc = JSON.parse(storage.getItem('selectedClient'))
            }
          }
          return sc;
        },
        getAgencyClients(id){
          return organizations.getSelectedAgencyClients(id).then(response => {
            const allOrganizationInfo = response.data;
            console.log(response.data);
            const allOrganizationMap = allOrganizationInfo
              .map(function (org) {               
                return {
                  name: org.Name,
                  id: org.Id,
                  travelAgencyId: org.TravelAgencyId,
                  allowOpenBookings: org.AllowOpenBookings,
                  ChatAppName: org.ChatAppName
                }
              })
              .sort(function (a, b) {
                return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
              });

            return $q.when(allOrganizationMap);
          });           
        },
        clearSelectedClient() {
          selectedClient.id = undefined;
          selectedClient.name = undefined;
          selectedClient.allowOpenBookings = undefined;
          selectedClient.ChatAppName = undefined
          storage.removeItem('selectedClient');
          console.log('selectedClient cleared');
        }
      }
    }])
})()



// WEBPACK FOOTER //
// ./client/js/services/clientSelect.service.js